module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-01.b8ac952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-01.png
// module id = UUIe
// module chunks = 1